import { CommonModule, Location } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { LeadsV2WorkflowConfigComponent } from './leads-v2-workflow-config.component';

@Component({
  selector: 'app-leads-v2-workflow-editor',
  standalone: true,
  imports: [
    CommonModule,
    LeadsV2WorkflowConfigComponent,
  ],
  templateUrl: './leads-v2-workflow-editor.component.html',
  styleUrls: ['./leads-v2-workflow-editor.component.css'],
})
export class LeadsV2WorkflowEditorComponent implements OnInit {
  @ViewChild(LeadsV2WorkflowConfigComponent)
  workflowEditor?: LeadsV2WorkflowConfigComponent;

  createMode = false;
  workflowKey: string | null = null;
  title = 'Workflow graph';

  get dirty(): boolean {
    return this.workflowEditor?.dirty ?? false;
  }

  constructor(
    private readonly route: ActivatedRoute,
    private readonly router: Router,
    private readonly location: Location,
  ) {}

  ngOnInit(): void {
    this.createMode = this.route.snapshot.data['create'] === true;
    this.workflowKey = this.createMode
      ? null
      : this.route.snapshot.paramMap.get('workflowKey');
    this.title = this.createMode ? 'New workflow' : 'Workflow graph';
  }

  onWorkflowCreated(workflowKey: string): void {
    this.createMode = false;
    this.workflowKey = workflowKey;
    this.title = 'Workflow graph';

    const url = this.router.serializeUrl(
      this.router.createUrlTree(['/smart-workflows', workflowKey, 'edit']),
    );
    this.location.replaceState(url);
  }

  onBackRequested(): void {
    this.router.navigate(['/smart-workflows']);
  }

}
